/*
 * @Descripttion: 
 * @version: 
 * @Author: wl
 * @Date: 2020-06-12 16:21:08
 * @LastEditors: wl
 * @LastEditTime: 2020-07-31 14:46:14
 */ 
import axios from '../axios'

/* 
 * 通行管理
 */


// 人员审核
export const personAudit = (data) => {
    
    return axios({
        url: '/admin/service/sys_person_audit',
        method: 'post',
        data
    })
    
}
//人员审核、
// 分页查询   service/sys_person_list（杨新潮说是不要了改成arry）
export const findPage = (data) => {
    return axios({
        url: '/admin/service/sys_person_list',
        method: 'post',
        data
    })
}   

// 审核记录
export const personAuditList = (data) => {
    return axios({
        url: '/admin/service/sys_personAudit_list',
        method: 'post',
        data
    })
}


//人员通行 /admin/service/sys_pass_list

export const personPassFind = (data) => {
    
    return axios({
        url: '/admin/service/sys_pass_list',
        method: 'post',
        data
    })
    
}
//黑名单预警 =

export const blackList_personPass_list = (data) => {
    
    return axios({
        url: '/admin/service/blackList_personPass_list',
        method: 'post',
        data
    })
    
}

// 通行策略查询接口
export const currentSeting = (data) => {
    
    return axios({
        url: '/admin/service/sys_currentSeting_list',
        method: 'post',
        data
    })
    
}

// 通行策略编辑接口

export const setingAdd = (data) => {
    
    return axios({
        url: '/admin/service/sys_currentSeting_add',
        method: 'post',
        data
    })
    
}
// 高温通行记录

export const pass_abnormal = (data) => {
    return axios({
      url: '/admin/service/sys_pass_abnormal',
      method: 'post',
      data
    })
  }


// WEBPACK FOOTER //
// ./src/http/moudules/personPass.js